var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3.2,
    fill: "#081439",
    fillOpacity: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9657 11.7659C19.2777 11.4539 19.2777 10.9475 18.9657 10.6344C18.6537 10.3212 18.1474 10.3224 17.8342 10.6344L18.9657 11.7659ZM13.5994 16.0007L13.0342 15.4355C12.7222 15.7475 12.7222 16.2539 13.0342 16.5671L13.5994 16.0007ZM17.8342 21.3659C18.1462 21.6779 18.6525 21.6779 18.9657 21.3659C19.2789 21.0539 19.2777 20.5475 18.9657 20.2343L17.8342 21.3659ZM17.8342 10.6344L13.0342 15.4355L14.1658 16.5659L18.9657 11.7659L17.8342 10.6344ZM13.0342 16.5659L17.8342 21.3659L18.9657 20.2343L14.1658 15.4343L13.0342 16.5659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.e61d2078e28a2d8ffcf9f6eabc6b6667.svg";
export { ForwardRef as ReactComponent };